import { render, staticRenderFns } from "./NewDiagnostic.vue?vue&type=template&id=414ad99c&"
import script from "./NewDiagnostic.vue?vue&type=script&lang=js&"
export * from "./NewDiagnostic.vue?vue&type=script&lang=js&"
import style0 from "./NewDiagnostic.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewDiagnostic.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports